import { Enum } from './Enum'

export default {
  // start

  tagTabEnum: new Enum()
    .add('1', '工厂', 'factory')
    .add('2', '品牌', 'brand')
    .add('3', '社会评价身份', 'socialIdentity')
    .add('4', '用户评价分类', 'reviewCategory')
    .add('5', '执行标准', 'executionStandard')
    .add('6', '销售渠道', 'salesChannel')
    .add('7', '举报原因', 'reportReason'),

jumpTypeEnum: new Enum()
 .add('1', '不跳转', 'no')
 .add('2', '小程序内部页面跳转', 'WXAPP')
    .add('3', '外部链接', 'URL')
    .add('4', 'banner详情', 'BANNER_DETAIL')
    .add('5', 'banner详情+跳转', 'BANNER_DETAIL_URL')
			.add('6', 'banner详情+复制链接', 'BANNER_URL_COPY'),
  // end


  jumpTypeinnerEnum: new Enum()
 .add('1', '小程序内部页面跳转', 'WXAPP')
    .add('2', '外部链接', 'URL'),








  userStatusEnum:new Enum()
    .add('1', '正常', true)
    .add('2', '封禁', false),
  simulateStatusEnum: new Enum()
    .add('1', '是', true)
    .add('2', '否', false),
  // 订单状态
  orderStatusEnum: new Enum()
    .add('1', '审核中', 'VERIFY')
    .add('2', '成功', 'SUCCESS')
    .add('3', '失败', 'FAIL'),
  // 申诉状态ok
  verifyStatusEnum: new Enum()
    .add('1', '未申诉', 'UN_COMPLAINT')
    .add('2', '申诉审核中', 'VERIFT')
    .add('3', '审核成功', 'SUCCESS')
    .add('4', '申诉失败', 'FAIL'),
  // 提现状态
  withdrawalStatusEnum: new Enum()
    .add('1', '审核中', 'VERIFY')
    .add('2', '提现成功', 'SUCCESS')
    .add('3', '提现失败', 'FAIL'),
  payTypeEnum: new Enum()
    .add('online', '在线支付', 'ONLINE')
    .add('prestorage', '预存款支付', 'PRE_STORAGE'),

  financeRecordTypeEnumWallect: new Enum()
    .add('1', '成功交易', 'TRADE')
    .add('2', '注册奖励', 'REGISTER')
    .add('3', '安装APP', 'INSTALL_APP')
    .add('4', '绑定WS', 'BIND_WS')
    .add('5', '交易次数', 'TRADE_NUM')
    .add('6', '推荐奖励', 'RECOMMENT')
    .add('7', '提现成功', 'WITHDRAW')
    // .add('7', '提现失败', 'WITHDRAW_FAIL')
    .add('8', '余额变动', 'BALANCE')
    .add('9', '签到', 'SIGN'),
  financeRecordTypeEnum: new Enum()
    .add('1', '成功交易', 'TRADE')
    .add('2', '注册奖励', 'REGISTER')
    .add('3', '绑定Whatsapp奖励', 'BIND_WS')
    .add('4', '交易次数奖励', 'TRADE_NUM')
    .add('4', '推荐奖励', 'RECOMMENT')
    .add('4', '-提现', 'WITHDRAW')
    .add('4', '+提现失败', 'WITHDRAW_FAIL'),
  authenticationTypeEnum: new Enum()
    .add('1', '品牌授权书', 'BRAND')
    .add('2', ' 商标注册书', 'TRADE_MARK')
    .add('3', '承印委托书', 'PROXY')
    .add('4', '品牌授权书/商标注册书', 'BRAND_TRADE_MARK'),

  refundStatusEnum: new Enum()
    .add('1', '待处理', 'VERIFY')
    .add('2', '处理中', 'VERIFYING')
    .add('3', '已处理', 'VERIFYED')
    .add('4', '驳回', 'REJECT')
    .add('5', '拒绝处理', 'REFUSE')
    .add('6', '处理完成', 'FINISH'),
  certificationTypeEnum: new Enum()
    .add('1', '个人认证', 'PERSONAL')
    .add('2', '企业认证', 'COMPANY'),
  certificationStatusEnum: new Enum()
    .add('1', '审核中', 'VERIFYING')
    .add('2', '审核失败', 'FAIL')
    .add('3', '审核成功', 'SUCCESS'),
  schemeStatusEnum: new Enum()
    .add('1', '退货减款', 'REFUND_PRICE')
    .add('2', '退货', 'REFUND')
    .add('3', '补印', 'REPRINT')
    .add('4', '减款', 'REDUCE_PRICE')
    .add('5', '其他', 'OTHER'),

}
